<template>
  <section>
    <BasicVideoPicsTextSwiper :title="title" :subtitle="subtitle" :imgs="imgs" id="10"></BasicVideoPicsTextSwiper>
  </section>
</template>
<script>
import BasicVideoPicsTextSwiper from '@/components/basic-videopicstext-swiper.vue'
export default {
  data() {
    return {
      title: '每时每刻 畅享便捷',
      subtitle:'徜徉便捷新时代，为您的行车体验注入无限便利与愉悦',
      imgs: [
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zx1.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zhixiangmob1.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '10.25英寸炫彩液晶仪表盘',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zx2.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zhixiang2mob.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '手机无线充电',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zx3.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zhixiang3mob.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '高级皮质座椅',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zx3-1.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/tcmob1.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '电动天窗',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        }
       /** ,{
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zx4.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zhixiangmob4.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '后排头枕高度可调',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zx5.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zhixiangmob5.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '前排头枕滑动',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zx6.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/zxjc/zhixiangmob6.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '后排座椅折叠（6:4）',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        } */
      ],
    }
  },
  components: {
    BasicVideoPicsTextSwiper
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
::v-deep .title-outer{
  padding-right: 8.333333vw;
  .main-title{
    font-size: calc(48/1920*100vw);

  }
}
::v-deep .my-weiper-container .swiper-container {

  .imgBox-mob{
    height: 60vw;
  }
  .swiper-pagination{
    top: 72vw  !important;
  }
  .swiper-slide-mob{
    height: 84vw;
  }
}
::v-deep .swiper-pagination-bullets .swiper-pagination-bullet{
  height: 2px;
  border-radius: 0;
}
</style>
